import { render } from "./SettingsTabPrecautionPresets.vue?vue&type=template&id=61d1342c&scoped=true"
import script from "./SettingsTabPrecautionPresets.vue?vue&type=script&lang=js"
export * from "./SettingsTabPrecautionPresets.vue?vue&type=script&lang=js"

import "./SettingsTabPrecautionPresets.vue?vue&type=style&index=0&id=61d1342c&scoped=true&lang=css"

import exportComponent from "C:\\work\\HIMSDeployTest\\HIMSFRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d1342c"]])

export default __exports__